import React from "react";
import { Range } from "react-range";

const MIN = 1;
const MAX = 1000;

export default function DualRangeSlider({ values, onChange }) {
  const displayValue = (v) => (v >= 1000 ? "1000+" : v);

  return (
    <div style={{ width: "100%", padding: "1rem 0" }}>
      <Range
        step={1}
        min={MIN}
        max={MAX}
        values={values}
        onChange={onChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            style={{
              height: "6px",
              width: "100%",
              background: "#e2e8f0",
              borderRadius: "4px",
              position: "relative",
              ...props.style,
            }}
          >
            <div
              style={{
                position: "absolute",
                height: "100%",
                background: "#4299e1",
                borderRadius: "4px",
                left: `${((values[0] - MIN) / (MAX - MIN)) * 100}%`,
                width: `${((values[1] - values[0]) / (MAX - MIN)) * 100}%`,
              }}
            />
            {children}
          </div>
        )}
        renderThumb={({ props, index }) => (
          <div
            {...props}
            style={{
              height: "20px",
              width: "20px",
              borderRadius: "50%",
              backgroundColor: "#2b6cb0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 0 2px rgba(0, 0, 0, 0.3)",
              ...props.style,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "28px",
                color: "#4a5568",
                fontWeight: "500",
                fontSize: "0.75rem",
                whiteSpace: "nowrap",
              }}
            >
              {displayValue(values[index])}
            </div>
          </div>
        )}
      />
    </div>
  );
}